import { REDIRECT_APP } from '@/constants/authentication';
import { routes } from '@/constants/routes';
import { useNavigate, useSearchParams, useParams } from 'react-router-dom';

type Params = {
  [key: string]: string;
};

export const useRedirectAppRouter = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const params = useParams();
  const lang = params.lang || 'en';

  const pushWithRedirectAppParam = (route: string, queryParams?: Params) => {
    const redirectApp =
      searchParams.get(REDIRECT_APP) || localStorage.getItem(REDIRECT_APP);
    const paramsString = queryParams
      ? Object.keys(queryParams || {})
          .map(key => `${key}=${queryParams[key]}`)
          .join('&')
      : '';

    // Prepend language prefix
    const fullRoute = `/${lang}${route}`;

    if (redirectApp) {
      navigate(
        `${fullRoute}?${REDIRECT_APP}=${redirectApp}${
          paramsString ? '&' + paramsString : ''
        }`
      );
    } else {
      navigate(`${fullRoute}${paramsString ? '?' + paramsString : ''}`);
    }
  };

  const getIndirectInviteRedirectParams = () => {
    const params: Params = {
      'indirect-inv': 'true',
      project: searchParams.get('project')!,
      stageId: searchParams.get('stageId')!,
    };

    if (searchParams.get('locale')) {
      params['locale'] = searchParams.get('locale')!;
    }

    if (searchParams.get('hms')) {
      params['hms'] = searchParams.get('hms')!;
    }

    return params;
  };

  const pushWithIndirectInvParams = (
    route: string,
    additionalParams?: Params
  ) => {
    pushWithRedirectAppParam(route, {
      ...getIndirectInviteRedirectParams(),
      ...additionalParams,
    });
  };

  const redirectToLoginWithEmail = (email: string | undefined) => {
    pushWithRedirectAppParam(
      routes.login,
      email ? { email: encodeURIComponent(email) } : undefined
    );
  };

  return {
    pushWithRedirectAppParam,
    pushWithIndirectInvParams,
    redirectToLoginWithEmail,
  };
};
